// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.best-seller .main-grid {
  padding-top: 0px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
}
.best-seller .main-grid .best-seller-heading {
  font-family: "Poppins";
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  color: #000000;
}

.best-seller .main-grid .best-seller-span-heading {
  font-family: "Karla";
  font-weight: 500;
  font-size: 22px;
  line-height: 25.72px;
  color: #000000;
}

.best-seller .table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
}
.best-seller .sub-grid .table-container {
  max-height: 380px;
  overflow-y: auto;
}
.best-seller .table th,
.best-seller .table td {
  border: none;
  border-bottom: none;
  text-align: center;
  font-family: "Karla";
  font-weight: 400;
  color: #000;
}
.best-seller .table th,
.best-seller .table td {
  border-right: 1px solid #000;
}
.best-seller .table-wrapper {
  border: 1px solid #000;
  border-collapse: collapse;
  border-spacing: 0; 
}
.best-seller .table-body td {
  border-top: none;
  /* border-bottom: 1px solid #000000; */
  border-collapse: collapse ;
}
.best-seller .table thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  border-collapse: collapse;
  box-shadow: inset 0 -1px 0 #000;
}
.best-seller .table th,
.best-seller .table td {
  text-align: center;
  font-family: "Karla";
  font-weight: 400;
  color: #000;
  border-right: 1px solid #000;
}
.best-seller .table th:last-child,
.best-seller .table td:last-child {
  border-right: none !important;
}
.best-seller .sub-grid .table-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Edge */
}`, "",{"version":3,"sources":["webpack://./src/components/ui/BestSellerModal/bestSeller.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,+BAA+B;AACjC;AACA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,4BAA4B;AAC9B;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,aAAa,EAAE,yBAAyB;AAC1C","sourcesContent":[".best-seller .main-grid {\n  padding-top: 0px !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 15px;\n}\n.best-seller .main-grid .best-seller-heading {\n  font-family: \"Poppins\";\n  font-weight: 500;\n  font-size: 24px;\n  line-height: 36px;\n  color: #000000;\n}\n\n.best-seller .main-grid .best-seller-span-heading {\n  font-family: \"Karla\";\n  font-weight: 500;\n  font-size: 22px;\n  line-height: 25.72px;\n  color: #000000;\n}\n\n.best-seller .table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background: #fff;\n}\n.best-seller .sub-grid .table-container {\n  max-height: 380px;\n  overflow-y: auto;\n}\n.best-seller .table th,\n.best-seller .table td {\n  border: none;\n  border-bottom: none;\n  text-align: center;\n  font-family: \"Karla\";\n  font-weight: 400;\n  color: #000;\n}\n.best-seller .table th,\n.best-seller .table td {\n  border-right: 1px solid #000;\n}\n.best-seller .table-wrapper {\n  border: 1px solid #000;\n  border-collapse: collapse;\n  border-spacing: 0; \n}\n.best-seller .table-body td {\n  border-top: none;\n  /* border-bottom: 1px solid #000000; */\n  border-collapse: collapse ;\n}\n.best-seller .table thead th {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 10;\n  border-collapse: collapse;\n  box-shadow: inset 0 -1px 0 #000;\n}\n.best-seller .table th,\n.best-seller .table td {\n  text-align: center;\n  font-family: \"Karla\";\n  font-weight: 400;\n  color: #000;\n  border-right: 1px solid #000;\n}\n.best-seller .table th:last-child,\n.best-seller .table td:last-child {\n  border-right: none !important;\n}\n.best-seller .sub-grid .table-container::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Edge */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
